<template>
<div id="card-details">
    <div id="infotitulo">
        <i class="pl-3 fas fa-clipboard-list"> </i> RESUMO
    </div>
    <div class="card-details-body mt-4 ml-3">
        <p class="label-details ">Status  </p>
        <div id="circle" >
        <p class="result-status" :style='statusColor'> {{statusText}} </p> </div>

        <p class="label-details">Corretor</p>
        <p class="result-details">{{selectedComissao.conta.nome}} </p>

        <p class="label-details">Valor Total da Comissão</p>
        <p class="result-details">{{selectedComissao.valorTotalComissaoFormatado}} </p>

        <p class="label-details">Porcentagem Comissão</p>
        <p class="result-details"> {{selectedComissao.credenciada.percentualComissao}}%</p>
        <p class="label-details">Valor Mensal</p>
        <p class="result-details">{{selectedComissao.valorParcelaFormatada}}</p>
    </div>
</div>
</template>

<script>
import Panelcommission from './panelcommission'
export default Panelcommission
</script>

<style scoped>

.subtitle{
    font-size: 18px;
    color: #008148;
    font-weight: bold;
}

.Pessoa{
    font-size:18px;
    text-align: center;
}
.label-details{
    font-size: 13px;
    color: #666;
    font-weight: 700;
    margin-bottom: 0;
}
.result-details{
    font-size: 15px;
    color: #2a2a2a;
}
.result-status{
    display:table; /* keep the background color wrapped tight */
    padding:5px;
    padding-left: 20px;
    padding-right: 20px;
    font-size:15px;

  /* background-color: #30a75f; */
    width: fit-content;
    color: white;
    border-radius: 16px;
    padding: 5px 20px;

}

#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}
#footer-card-details{
    display: flex;
    font-size: 16px;
    font-weight: bold;
    color: #4F4C4D;
    justify-content: center;
}

#infotitulo{
    height: 50px;
    width: 100%;
    font-size: 18px;
    background-color: #008148;
    padding-top: 15px;
    color: #fff;
}
hr{
    width: 95%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/panelcommission/panelcommission.vue